export default {
    SET_ACCORDION_OPTIONS : "UPDATE_ACCORDION_OPTIONS",
    SET_HOME_ACCORDIONS: "SET_HOME_ACCORDIONS",
    SET_ACCORDION_CONTENT: "SET_ACCORDION_CONTENT",
    SET_ACCORDION_FOOTER: "SET_ACCORDION_FOOTER",
    SET_LOADING_STATUS: "SET_LOADING_STATUS",
    SET_LAWLEX_LOADING_STATUS: "SET_LAWLEX_LOADING_STATUS",
    SET_LAWLEX_RECENT_SEARCHES: 'SET_LAWLEX_RECENT_SEARCHES',
    SET_LAWLEX_NEWSFEEDS: 'SET_LAWLEX_NEWSFEEDS',
}